/* eslint-disable camelcase */
const {
  REACT_APP_awsBucketName, REACT_APP_awsUserRoleArn, REACT_APP_baseApiGatewayUrl,
  REACT_APP_clientId, REACT_APP_returUrl, REACT_APP_mcdLoginUrl, REACT_APP_mcdLogoutUrl,
  REACT_APP_deploymentUrl
} = process.env;
/** Staging/prod environment configuration */
export const returUrl = REACT_APP_returUrl;
export const clientId = REACT_APP_clientId;
export const baseApiGatewayUrl = REACT_APP_baseApiGatewayUrl;
export const mcdLoginUrl = REACT_APP_mcdLoginUrl;
export const mcdLogoutUrl = REACT_APP_mcdLogoutUrl;
export const awsBucketName = REACT_APP_awsBucketName;
export const awsUserRoleArn = REACT_APP_awsUserRoleArn;
export const deploymentApiUrl = REACT_APP_deploymentUrl;
